module.exports = __webpack_public_path__ + "static/img/refreshBanner_2020-01-27_PCH.1caa8f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/refreshBanner_2020-01-27_PCH.png
// module id = DI7g
// module chunks = 1